var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.topTitles)?_c('div',{staticClass:"web_top_title"},[_c('div',{staticClass:"top_title_main",domProps:{"textContent":_vm._s(_vm.titles)}}),_vm._v(" "),_c('div',{staticClass:"top_title_sub",domProps:{"textContent":_vm._s(_vm.titlesCon)}})]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f9beee2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Titles.vue
// module id = 501
// module chunks = 1